module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: '<img class="plg_left_arrow<%= leftArrowClass %>" src="img/arrow_left.png" />\n<div class="owl-carousel"></div>\n<img class="plg_right_arrow<%= rightArrowClass %>" src="img/arrow_right.png" />\n',
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push('<img class="plg_left_arrow', escape((__stack.lineno = 1, leftArrowClass)), '" src="img/arrow_left.png" />\n<div class="owl-carousel"></div>\n<img class="plg_right_arrow', escape((__stack.lineno = 3, rightArrowClass)), '" src="img/arrow_right.png" />\n');
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// /home/app/terminal/release/1773157763-2.1.11/node_modules/ejs-compiled-loader!./src/templates/header_dates_groups.ejs
// module id = 131
// module chunks = 0